import moment from "moment";
import { CurrentCredentials } from "./currentCredentials";

class connectionCache{
    public request:string;
    public resolves : any[];
    public rejects : any[];
    public creationTime : moment.Moment;
    public finishTime : moment.Moment;
    
    constructor() {
        this.resolves = [];
        this.rejects = [];
        this.creationTime = moment.utc();
    }

    finish(){
        this.finishTime = moment.utc();        
    }
    success(resp){
        this.finish();
        this.resolves.forEach(x=>x(JSON.parse(resp)));
    }
    fail(status,statusText){
        this.finish();
        this.rejects.forEach(x=>x({ status: status, statusText: statusText }));
    }
}

export class ServerConnection{
    private static _caches :connectionCache[] = []; 

    public static callServerWithUsernameAndPassword(service: string, body: Object,username:string,password:string,macAddresses:string[]=[]): Promise<any> {
        
        if(macAddresses==null || macAddresses.length==0){
            macAddresses = CurrentCredentials.macAddresses;
        }
        for(let i=ServerConnection._caches.length-1;i>=0;i--){
            if(ServerConnection._caches[i].finishTime!=null){
                ServerConnection._caches.splice(i,1);
            }
        }
        
        (<any>body).AuthenticationInformation= { Username: username, Password: password,MacAddresses:macAddresses };
        (<any>body).UsedInternally_WebServiceManualOperationTime=null;
        let requestBody = `${service}\r\n${JSON.stringify(body)}`;
        
        return new Promise<JSON>((resolvedFunction, rejectFunction) => {
            let existingCache = ServerConnection._caches.filter(x=>x.request==requestBody).at(0);
            let newCache : connectionCache = null;
            if(existingCache==null){
                newCache = new connectionCache();
                newCache.request = requestBody;
                ServerConnection._caches.push(newCache);
            }else{
                existingCache.resolves.push(resolvedFunction);
                existingCache.rejects.push(rejectFunction);
                return;
            }

            let request = new XMLHttpRequest();
            //let url = 'http://localhost:48009/api';
            let url = 'https://sale.iranautoparts.com/api';
            
            request.open('POST',url);
            
            request.onload = function () {
                if (this.status == 200) {
                    let result = JSON.parse(request.response);
                    if(result.HasCatastrophicError==false){
                        newCache.success(request.response);
                        resolvedFunction(JSON.parse(request.response));
                    }else{
                        newCache.fail(request.status,result.Faults[0]);
                        rejectFunction({ status: request.status, statusText: result.Faults[0] });
                    }
                } else {
                    newCache.fail(request.status,request.statusText);
                    rejectFunction({ status: request.status, statusText: request.statusText });
                }
            }
            request.onerror = function () { 
                newCache.fail(request.status,request.statusText);
                rejectFunction({ status: request.status, statusText: request.statusText }); 
            }
            request.send(requestBody);
        })
    }

    public static callServer(service: string, body: Object): Promise<any> {
        return this.callServerWithUsernameAndPassword(service,body,CurrentCredentials.username,CurrentCredentials.password,CurrentCredentials.macAddresses);
    }
}